import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Dispatch, StoreState } from "../../../store";

interface Props {
  onAdd?: () => void;
}

export default function AddCustomerGroup({ onAdd }: Props) {
  const classes = useStyles();
  const dispatch = useDispatch<Dispatch>();

  const filterResultCount = useSelector(
    (state: StoreState) => state.customerGroupResult.meta.count
  );
  const isValidCustomerGroup = () => {
    return filterResultCount > 0;
  };

  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [groupName, setGroupName] = useState<string | null>(null);
  const handleShowCreateDialog = () => {
    setShowCreateDialog(true);
  };
  const handleCloseCreateDialog = () => {
    setGroupName(null);
    setShowCreateDialog(false);
  };
  const handleGroupNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setGroupName(event.target.value);
  };
  const isValidGroupName = () => {
    return groupName !== null && groupName.length > 0;
  };
  const handleSaveClick = () => {
    if (!isValidGroupName()) {
      return;
    }
    if (typeof onAdd === "function") onAdd();
    dispatch.activeCustomerGroup.setActiveCustomerGroup(null);
    dispatch.customerGroupEditOption.setCustomerGroupEditOption(null);
    dispatch.customerGroupList.saveCustomerGroup(groupName as string);
    handleCloseCreateDialog();
  };

  return (
    <>
      <Grid item>
        <Card
          className={`${classes.card} ${classes.newCard}`}
          variant="outlined"
        >
          <CardContent className={classes.newCardContent}>
            <Tooltip title="Kundengruppe speichern">
              <span>
                <IconButton
                  onClick={handleShowCreateDialog}
                  disabled={!isValidCustomerGroup()}
                >
                  <AddCircleOutlineIcon fontSize="large" />
                </IconButton>
              </span>
            </Tooltip>
          </CardContent>
        </Card>

        <Dialog open={showCreateDialog} onClose={handleCloseCreateDialog}>
          <DialogTitle id="form-dialog-title">Kundengruppenname</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bitte geben Sie den Namen der neuen Kundengruppe ein.
            </DialogContentText>
            <TextField
              onChange={handleGroupNameChange}
              value={groupName}
              autoFocus
              margin="dense"
              id="name"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseCreateDialog} color="primary">
              Abbrechen
            </Button>
            <Button
              onClick={handleSaveClick}
              disabled={!isValidGroupName()}
              color="primary"
            >
              Speichern
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      minWidth: 220,
      minHeight: "100%",
      backgroundColor: theme.palette.background.default,
    },
    content: {
      height: 40,
    },
    newCard: {
      borderStyle: "dashed",
      borderWidth: "medium",
      height: "100%",
      minHeight: 190,
    },
    newCardContent: {
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroup/AddCustomerGroup.tsx